import { Laptop } from 'lucide-react'
import { Shell, useShellMeta } from '../admin/Shell.js'
import {
  useHubData, HubHero, ServiceStateLine, AttentionSection, ActivitySection, heroMood,
} from './FamilyHub.js'
import { pickMetrics } from './SecurityHub.js'

/* ═══════════════════════════════ PARC ═══════════════════════════════════
   « Voilà ce qui se passe avec le matériel maintenant. »                  */

const PARC_METRIC_PRIORITY = [
  'overdue_returns', 'returns_due_today', 'rentals_in_progress',
  'assets_unavailable', 'assets_out', 'pending_needs',
]

export function ParcHub() {
  const meta = useShellMeta()
  const data = useHubData('parc')
  const parc = data?.services.find((s) => s.key === 'parc') ?? data?.services[0]

  const titre = !parc || parc.never_contacted
    ? 'Aucune donnée fiable disponible'
    : parc.status === 'DOWN'
      ? 'Parc indisponible'
      : parc.headline?.title ?? 'Parc'
  const detail = !parc || parc.never_contacted
    ? 'Gestion n’a pas encore pu joindre le Parc — nouvel essai automatique.'
    : parc.status === 'DOWN'
      ? 'Gestion conserve les dernières données fiables et réessaie automatiquement.'
      : parc.headline?.detail

  return (
    <Shell active="parc" meta={meta}>
      <main className="lc-page lc-stagger hub--parc">
        <HubHero
          familyLabel="Parc"
          Icon={Laptop}
          title={titre}
          detail={detail}
          mood={heroMood(parc)}
          cta={parc?.primary_action ?? null}
          metrics={parc && !parc.never_contacted ? pickMetrics(parc, PARC_METRIC_PRIORITY) : []}
          serviceLine={parc ? <ServiceStateLine svc={parc} /> : null}
        />

        <AttentionSection
          alerts={data?.alerts ?? []}
          total={data?.alerts_active_total ?? 0}
          allLink="/alerts?service=parc&state=active"
          Icon={Laptop}
          emptyText={data ? 'Aucun retour urgent ni incident matériel.' : '…'}
        />

        <div className="hub-columns">
          <ActivitySection
            activity={data?.activity ?? []}
            emptyText="Aucune activité récente côté Gestion pour cette famille."
          />
          <section className="lc-panel" aria-label="Application">
            <header className="lc-panel__head"><h2 className="lc-section-title">Application</h2></header>
            <div className="lc-panel__body lc-panel__body--flush hub-soon">
              <div className="hub-soon__row">
                <span className="hub-soon__name">
                  <span className="hub-soon__icon" style={{ background: 'var(--grad-amber)', color: '#fff' }}><Laptop size={17} /></span>
                  Parc / Inventaire
                </span>
                {parc && !parc.never_contacted && parc.status === 'OK' && !parc.stale
                  ? <span className="lc-pill lc-pill--ok"><span className="lc-dot lc-dot--ok lc-dot--live" />Connecté</span>
                  : parc && parc.stale
                    ? <span className="lc-pill lc-pill--warning">Données périmées</span>
                    : <span className="lc-pill lc-pill--idle">{parc?.status ?? 'Aucune donnée'}</span>}
              </div>
            </div>
          </section>
        </div>
      </main>
    </Shell>
  )
}

/* Le hub Communication « vitrine » a été REMPLACÉ par le cockpit du module
   Communication V1 (communication/CommunicationHome.tsx) : vraies données,
   page personnalisable. Ce fichier ne garde que le Parc. */
